module.exports = __webpack_public_path__ + "img/send-help-tutorial-first-frame.3379470c.png";